import React from 'react';

const SEPARATOR_SPACING = 25;

// eslint-disable-next-line import/prefer-default-export
export const DimensionFieldSeparator = () => (
  <hr style={{ marginTop: SEPARATOR_SPACING, marginBottom: SEPARATOR_SPACING, marginRight: 'calc(100% - 300px)' }} />
);
